<template>
    <div id="app" :class="['page-' + $router.currentRoute.name.toLowerCase(), $router.currentRoute.meta.topClass ? 'top-' + $router.currentRoute.meta.topClass : '']">
        
        <div id="wrapper" class="">
            <!-- <router-view :key="$route.fullPath"/> -->
            <keep-alive max="2">
                <router-view :key="$route.fullPath"/>
            </keep-alive>            
        </div>

    </div>
</template>

<script>
import Top from './components/Top'

export default {
    name: 'App',
    components: {
        'Top': Top,
    },
    methods: {        
        data () {
            var self                    = this;
            return {        
            }
        },        
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + " " + time;
        }       
    }
}
</script>

<style>
    #app {


    }
    .modal-termos-de-uso h3 {
        width: 90%;
        display: block;
    }
    .modal-termos-de-uso ul {
        margin-bottom: 0px;
    }
    .modal-termos-de-uso li {
        text-align: justify;
        font-size: 14px;
        color: #000;
    }
    .modal-termos-de-uso p {
        text-align: justify;
        margin-bottom: 0px;
        color: #000;
    }
    .modal-politicas-de-privacidade ul {
        margin-bottom: 0px;
    }
    .modal-politicas-de-privacidade li {
        text-align: justify;
        font-size: 14px;
        color: #000;
    }
    .modal-politicas-de-privacidade p {
        text-align: justify;
        margin-bottom: 0px;
        color: #000;
    }    
    .modal-politicas-de-privacidade h3 {
        width: 90%;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue